"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationOverviewInfo = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ReservationOverviewInfoFlights_1 = require("./ReservationOverviewInfoFlights");
const ReservationOverviewInfoTable_1 = require("./ReservationOverviewInfoTable");
const ReservationOverviewInfoTotal_1 = require("./ReservationOverviewInfoTotal");
require("./index.scss");
const defaultTitle = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary:Title', defaultMessage: 'Summary' }));
const ReservationOverviewInfo = (props) => {
    const { className, flights, totalPrice, passengers, title = defaultTitle, } = props;
    const classNames = (0, classnames_1.default)('reservation-overview-info', className);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("h2", { className: 'reservation-overview-info__title' }, title),
        react_1.default.createElement(ReservationOverviewInfoFlights_1.ReservationOverviewInfoFlights, { flights: flights, className: 'reservation-overview-info__flights' }),
        react_1.default.createElement(ReservationOverviewInfoTable_1.ReservationOverviewInfoTable, { className: 'reservation-overview-info__table', passengers: passengers }),
        react_1.default.createElement(ReservationOverviewInfoTotal_1.ReservationOverviewInfoTotal, { className: 'reservation-overview-info__total', price: totalPrice })));
};
exports.ReservationOverviewInfo = ReservationOverviewInfo;
//# sourceMappingURL=index.js.map